import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../api/axiosInstance";

export const fetchSurvey = createAsyncThunk("profile/fetch", async (publicId, thunkAPI) => {
  try {
    const res = await api.get(`/profile/${publicId}`, { withCredentials: true });
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to load profile");
  }
});

export const saveSurvey = createAsyncThunk(
  "profile/saveProfile",
  async (profileData, thunkAPI) => {
    try {
      const response = await api.post("/profile/survey/save", profileData); // automatically sends credentials

      if (!response.data.success) {
        return thunkAPI.rejectWithValue("Failed to save");
      }

      return response.data;
    } catch (error) {
      console.error("saveProfile error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Server error"
      );
    }
  }
);

export const updateSurvey = createAsyncThunk(
  "profile/updateProfile",
  async (profileData, thunkAPI) => {
    try {
      const response = await api.put("/qlinks/update", profileData); // automatically sends credentials

      if (!response.data.success) {
        return thunkAPI.rejectWithValue("Failed to save");
      }

      return response.data;
    } catch (error) {
      console.error("saveProfile error:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Server error"
      );
    }
  }
);

export const getPublicSurvey = createAsyncThunk(
  "qLinks/getPublicProfile",
  async (username, thunkAPI) => {
    try {
      const res = await api.get(`/qlinks/profile/${username}`);
      if (!res.data.success) {
        return thunkAPI.rejectWithValue(res.data.error || "Profile not found");
      }
      return res.data.profile;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error || "Server error");
    }
  }
);

export const deleteProfile = createAsyncThunk(
  "qLinks/deleteProfile",
  async ({publicId, userId, username}, thunkAPI) => {
    try {
      console.log(username)
      const res = await api.delete(`/qlinks/profile/${username}/delete`, {data: {publicId, userId},});
      if (!res.data.success) {
        return thunkAPI.rejectWithValue(res.data.error || "Profile not found");
      }
      return res.data.profile;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error || "Server error");
    }
  }
);


const surveySlice = createSlice({
  name: 'profile',
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    clearStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveSurvey.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(saveSurvey.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(saveSurvey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to save profile";
      })
      .addCase(getPublicSurvey.pending, (state) => {
        state.publicProfileLoading = true;
        state.publicProfileError = null;
      })
      .addCase(getPublicSurvey.fulfilled, (state, action) => {
        state.publicProfileLoading = false;
        state.publicProfile = action.payload;
      })
      .addCase(getPublicSurvey.rejected, (state, action) => {
        state.publicProfileLoading = false;
        state.publicProfileError = action.payload || "Unknown error";
      });
  },
});

export const { clearStatus } = surveySlice.actions;
export default surveySlice.reducer;